module.exports = __webpack_public_path__ + "img/11_13.f09fd27c.png";